export default "__VITE_ASSET__BpFOJkbY__"